export default {
      id: "sensors__temperature-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#sensors__temperature",
      toString: function () {
        return this.url;
      }
    }